import { GeneratedImage } from 'types'
import { MediaFileClient } from 'api/clients/MediaFileClient'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useUploadsProject } from 'hooks/useUploadsProject'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { insertImage } from '../UploadsTab/insertImage'
import { IMediaFile } from '../UploadsTab/Types'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { SelectedImage } from 'types'
import { useImportMediaFiles } from 'hooks/useImportMediaFiles'
import { useRootStore } from 'stores/RootStore'

export const useUploadAndInsert = () => {
  const workspaceId = useCurrentWorkspaceId()
  const uploadsProject = useUploadsProject(workspaceId)?.data?.project
  const editor = useEditor()
  const { uploadImageFiles } = useImportMediaFiles(false)
  const { drawersStore } = useRootStore()

  const uploadAndInsert = async (img: GeneratedImage) => {
    if (!uploadsProject) return

    const fetchResponse = await fetch(img.url)
    const blob = await fetchResponse.blob()
    const file = new File([blob], 'AI Generated Image', { type: img.mimeType })
    const uploadedImages = await uploadImageFiles([file], uploadsProject.id)
    if (!uploadedImages) return []
    const images = uploadedImages.map((file) => ({ id: file.id, url: file.source_url } as SelectedImage))
    const image = images[0]
    if (!image?.id) return
    const response = await MediaFileClient.getAlmanacFile(image.id)
    if (response.type !== SUCCESS_RESPONSE_TYPE) {
      return
    }
    insertImage(editor, response.data.almanac_file as IMediaFile)
    drawersStore.closeDrawer()
  }

  return { uploadAndInsert }
}
